module.exports = __webpack_public_path__ + "static/media/card-login.33624cd0.png";